import { Grid, Tab, Tabs } from '@mui/material';
import React from 'react'
import { NewsPage } from './NewsPage';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import { TabPanel, tabPropsFunc } from '../Base/Account/Account';
import { NewsTypes } from '../../Component/Model/Enum/News';
import { MDBox } from '../../Component/Common/Components/MDBox';
import { MDTypography } from '../../Component/Common/Components/MDTypography';

export const NewsBase = () => {
    const [tabValue, setTabValue] = React.useState<number>(0);

    const handleTabValueChanged = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    }

    return (
        <div className="center">
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    News
                </MDTypography>
            </MDBox>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={tabValue} onChange={handleTabValueChanged} aria-label="TabswithIcons" centered>
                        <Tab icon={<NewspaperIcon />} label="Latest News" {...tabPropsFunc(0)}/>
                        <Tab icon={<NewspaperIcon />} label="BEEngaged Magazine" {...tabPropsFunc(1)}/>
                    </Tabs>
                    <TabPanel value={tabValue} index={0}>
                        <NewsPage newsType={NewsTypes.All}/>
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <NewsPage newsType={NewsTypes.BEEngaged}/>
                    </TabPanel>
                </Grid>
            </Grid>
        </div>
    );
}
